// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__yCPuB","spin":"Spinner_spin__xyVYo","container":"Spinner_container__fHwGY"};